import { useEffect, useRef } from "react";

let activeLockCount = 0;
let originalOverflow: string | null = null;
let originalPaddingRight: string | null = null;

const lockScroll = () => {
	const body = document.body;

	if (activeLockCount === 0) {
		originalOverflow = body.style.overflow;
		originalPaddingRight = body.style.paddingRight;

		const computedPaddingRight = Number.parseFloat(window.getComputedStyle(body).paddingRight) || 0;
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		body.style.overflow = "hidden";
		if (scrollbarWidth > 0) {
			body.style.paddingRight = `${computedPaddingRight + scrollbarWidth}px`;
		}
	}

	activeLockCount += 1;
};

const unlockScroll = () => {
	if (activeLockCount === 0) {
		return;
	}

	activeLockCount -= 1;

	if (activeLockCount === 0) {
		document.body.style.overflow = originalOverflow ?? "";
		document.body.style.paddingRight = originalPaddingRight ?? "";
		originalOverflow = null;
		originalPaddingRight = null;
	}
};

export const useScrollLock = ({ enabled }: { enabled: boolean }) => {
	const isLockedRef = useRef(false);

	useEffect(() => {
		if (enabled) {
			lockScroll();
			isLockedRef.current = true;
		} else if (isLockedRef.current) {
			unlockScroll();
			isLockedRef.current = false;
		}

		return () => {
			if (isLockedRef.current) {
				unlockScroll();
				isLockedRef.current = false;
			}
		};
	}, [enabled]);
};
